<template>
  <div v-if="props.itemList" class="breadcrumb">
    <nuxt-link to="/" class="breadcrumb__parent">WARCエージェント</nuxt-link>
    <span
      v-for="(item, index) in props.itemList"
      :key="index"
      class="breadcrumb__child"
    >
      <nuxt-link v-if="item.url" :to="item.url" class="breadcrumb__item">
        {{ item.title }}
      </nuxt-link>
      <span v-else class="breadcrumb__item_current">{{ item.title }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  itemList: BreadcrumbItem[];
}
const props = withDefaults(defineProps<Props>(), {
  itemList: () => [],
});

useJsonld({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: (
    [{ title: 'WARCエージェント', url: fullUrl('') }] as BreadcrumbItem[]
  )
    .concat(props.itemList)
    .map((s, key) => {
      return {
        '@type': 'ListItem',
        position: key + 1,
        name: s.title,
        item: s.url,
      };
    }),
});
</script>
